















































































import { Component } from "vue-property-decorator";
import { CategoriasService, Categoria } from "@/services/categorias.service";
import { CatalogosService } from "@/services/catalogos.service";
import Loading from "@/shared/components/loading.vue";
import Confirm from "@/shared/components/confirm.vue";
import Manter from "./Manter.vue";
import EscolherNovaCategoria from "./EscolherNovaCategoria.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    Loading,
    Manter,
    Confirm,
    EscolherNovaCategoria,
  },
})
export default class Categorias extends mixins(GlobalMixin) {
  categorias = [] as Categoria[];
  idCatalogo = "";
  loading = false;
  treeData = [
    {
      root: true,
      idCatalogo: "",
      nome: "",
      categorias: [] as Categoria[],
    },
  ];
  categoriasAbertas = [];

  mounted() {
    this.categoriasAbertas = [];
    this.loading = true;
    this.idCatalogo = this.$route.params.idCatalogo;
    CatalogosService.obterCatalogo(this.idCatalogo).then((x) => {
      this.treeData[0].nome = `Categorias do Catálogo ${x.nome}`;
    });
    this.fetchCategorias();
  }

  handleOnOpenItem(arrayCategorias: any){
    this.categoriasAbertas = arrayCategorias;
  }

  async fetchCategorias() {
    this.loading = true;
    this.treeData[0].categorias = await CategoriasService.listarCategorias(
      this.idCatalogo
    );
    this.loading = false;
  }

  async novaSubCategoria(categoriaPai: Categoria) {
    const modal = this.$refs.manter as Manter;
    await modal.novaCategoria(categoriaPai.idCategoria);
    this.fetchCategorias();
  }

  async editarCategoria(categoria: Categoria) {
    const modal = this.$refs.manter as Manter;
    await modal.editarCategoria(categoria.idCategoria);
    this.fetchCategorias();
  }
  async deletarCategoria(categoria: Categoria) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir Categoria ${categoria.nome}`;
    const text = `Deseja realmente excluir a categoria ${categoria.nome} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      const existe = await CategoriasService.existeProdutoPorCategoria(
        categoria.idCategoria
      ).finally(this.stopLoader);
      if (existe) {
        const modal = this.$refs.escolher as EscolherNovaCategoria;
        await modal.escolherNovaCategoria(categoria.idCategoria);
      } else {
        this.startLoader();
        await CategoriasService.excluirCategoria(
          categoria.idCategoria,
          ""
        ).finally(this.stopLoader);
      }

      this.fetchCategorias();
    }
  }
  async atualizarCatalogoConsultor() {
    this.loading = true;
    await CategoriasService.atualizarCatalogoConsultor(this.idCatalogo);
    this.loading = false;
  }
}
